




























import { Component, Prop, Vue } from "vue-property-decorator";
import { IOrder } from "@/@types/orders/new-order";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { ICategory, IProductCard } from "@/@types/menu/menu/menu";

import BarOrderConstructorOrder from "./bar-order-constructor/bar-order-constructor-order.vue";
import BarOrderConstructorCategorys from "./bar-order-constructor/bar-order-constructor-categorys.vue";
import BarOrderConstructorDishs from "./bar-order-constructor/bar-order-constructor-dishs.vue";

@Component({
  components: {
    order: BarOrderConstructorOrder,
    categorys: BarOrderConstructorCategorys,
    dishs: BarOrderConstructorDishs,
  },
})
export default class OrderConstructoprMain extends Vue {
  @Prop({ type: Array, default: () => [] }) orders!: Array<IOrder>;
  @Prop({ type: Object, default: null }) order!: IOrder;
  @Prop({ type: Object, default: null }) vroom!: IVirtualRooma;
  @Prop({ type: Number, default: 0 }) guestIndex!: number;
  @Prop({ type: String, default: null }) orderCoast!: string;
  @Prop({ type: String, default: null }) search!: string;
  @Prop({ type: Array, default: () => [] }) menu!: Array<IProductCard>;
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICategory>;

  isActiveCat = 0;
  isActiveDish = 0;
  category = "";

  get slicingcategoryslist(): ICategory[][] {
    const size = this.categorys.length > 14 ? 14 : 15;
    const subarray = [];
    for (let i = 0; i < Math.ceil(this.menu.length / size); i++) {
      subarray[i] = this.categorys.slice(i * size, i * size + size);
    }
    return subarray;
  }

  get categoryList(): Array<ICategory> {
    return this.slicingcategoryslist[this.isActiveCat];
  }

  get getMenuBiStoreId(): Array<IProductCard> {
    return this.menu.filter((el) => {
      if (el.shop_id == this.order.cart[0].shop_id) {
        if (el.category == this.category) {
          if (this.search) {
            const search = this.search && this.search.toLowerCase();
            if (this.$getLocale(el.name))
              return (
                this.$getLocale(el.name)
                  .toLowerCase()
                  .indexOf(search.toLowerCase()) > -1
              );
          } else return el;
        }
      }
    });
  }

  get slicinglist(): IProductCard[][] {
    const size = this.getMenuBiStoreId.length > 19 ? 19 : 20;
    const subarray = [];
    for (let i = 0; i < Math.ceil(this.menu.length / size); i++) {
      subarray[i] = this.getMenuBiStoreId.slice(i * size, i * size + size);
    }
    return subarray;
  }

  get dishs(): Array<IProductCard> {
    return this.slicinglist[this.isActiveDish];
  }

  add(dishid: string): void {
    const dish = this.order.cart.find((el) => el.item_id == dishid);
    if (dish) dish.count++;
    else {
      const d = this.menu.find((el) => el._id == dishid);
      if (!d) return;

      this.order.cart.push({
        item_id: dishid,
        shop_id: d.shop_id,
        name: d.name,
        count: 1,
        params: d.params[0],
      });
    }
    this.$emit("changeCount", { cart: this.order.cart });
  }
}
